<template>
  <div
    qaid="customization-summary-bar"
    :class="{'translate-y-full': isCustomizationDrawerOpen}"
    class="customization-summary-bar fixed w-full z-[9998] bottom-0 left-0 bg-white p-2 flex flex-col md:flex-row transition-transform duration-200"
  >
    <button
      qaid="customization-summary-bar-content"
      class="customization-summary-bar__content h-12 md:h-auto w-full bg-blue-20 hover:bg-blue-10 transition-colors flex justify-between items-center px-2"
      aria-controls="customization-summary-dialog"
      aria-haspopup="true"
      :aria-expanded="isCustomizationSummaryDialogOpen"
      @click="openCustomizationSummaryDialog"
    >
      <div class="text-xs" qaid="customization-summary-bar-model-name">{{ bikeData.modelName }}</div>
      <div class="flex items-center justify-center">
        <div class="text-sm font-medium" qaid="customization-summary-bar-price">
          {{ bikeData.calculatedAdvertised }}
        </div>
        <pdl-icon
          class="ml-1 flex justify-center"
          name="info_outline"
          qaid="customization-summary-bar-info-icon"
          :label="$t('product.fdp.customizable.config.buildSummary.view')"
        />
      </div>
    </button>
    <div class="w-full md:min-w-fit md:max-w-xs">
      <customization-submit-to-retailer-button />
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import CustomizationSubmitToRetailerButton from '@/components/containers/buy-zone/customization/CustomizationSubmitToRetailerButton.vue';
import {PdlIcon} from '@pedal/pdl-icon';
import {SUMMARY_DIALOG_VIEWS} from '@/familyDetailsPage/store/bike-customization.js';

export default {
  components: {
    CustomizationSubmitToRetailerButton,
    PdlIcon,
  },
  computed: {
    ...mapState('bikeCustomization', ['bikeData', 'isCustomizationDrawerOpen', 'isCustomizationSummaryDialogOpen']),
  },
  methods: {
    ...mapMutations('bikeCustomization', ['setIsCustomizationSummaryDialogOpen', 'setSummaryDialogView']),

    openCustomizationSummaryDialog() {
      this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.BUILD_SUMMARY);
      this.setIsCustomizationSummaryDialogOpen(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.customization-summary-bar {
  box-shadow: 0 -15px 15px -3px rgba(0, 0, 0, 0.1);

  &__content {
    border-radius: 0.5rem 0.5rem 0 0;

    &:focus-visible {
      outline: 2px solid var(--blue-100);
      outline-offset: 2px;
    }

    @media (screen(md)) {
      border-radius: 0.5rem 0 0 0.5rem;
    }
  }
}

:deep(.button.customization-send-to-retailer-button) {
  border-radius: 0 0 0.5rem 0.5rem;

  @media (screen(md)) {
    border-radius: 0 0.5rem 0.5rem 0;
  }
}
</style>
